'use strict';

var isFunction = require('./is-function.js');
var isObject = require('./is-object.js');
var isDate = require('./is-date.js');
var isEqualDate = require('./is-equal-date.js');
var propTypes = require('./prop-types.js');
require('@babel/runtime/helpers/defineProperty');
require('prop-types/factoryWithTypeCheckers');
require('./constants.js');

/**
 * @license
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 */
/**
 * Check if the two parameters passed are equals.
 *
 * @function
 * @param {*} firstValue - Value to be compared.
 * @param {*} secondValue - Value to be compared.
 * @returns {boolean} - Returns true if both are equals, false otherwise.
 * @example
 * isEqual('string', 'string');
 * // => true
 */

var isEqual = function isEqual(firstValue, secondValue) {
  if (Object.is(firstValue, secondValue)) {
    return true;
  }

  if (firstValue && firstValue.constructor === Symbol && secondValue && secondValue.constructor === Symbol) {
    return firstValue.toString() === secondValue.toString();
  }

  if (isFunction(firstValue) && isFunction(secondValue)) {
    return firstValue.toString() === secondValue.toString();
  }

  if (isObject(firstValue) && isObject(secondValue)) {
    var keysA = Object.keys(firstValue);
    var keysB = Object.keys(secondValue);

    if (keysA.length !== keysB.length) {
      return false;
    }

    if (keysA.some(function (key) {
      return !keysB.includes(key);
    }) || keysB.some(function (key) {
      return !keysA.includes(key);
    })) {
      return false;
    }

    if (keysA.some(function (key) {
      return !isEqual(firstValue[key], secondValue[key]);
    })) {
      return false;
    }

    return true;
  }

  if (Array.isArray(firstValue) && Array.isArray(secondValue)) {
    if (firstValue.length !== secondValue.length) {
      return false;
    }

    if (firstValue.some(function (item, index) {
      return !isEqual(firstValue[index], secondValue[index]);
    })) {
      return false;
    }

    return true;
  }

  if (isDate(firstValue) && isDate(secondValue)) {
    return isEqualDate(firstValue, secondValue);
  }

  return false;
};

isEqual.HELPER_ID = 'Gearz.JsUtils.isEqual';
isEqual.returnType = propTypes.boolWithDescription('Returns true if both values are equals, false otherwise.');
isEqual.parameterTypes = {
  firstValue: propTypes.anyWithDescription('First value to be compared.'),
  secondValue: propTypes.anyWithDescription('Second value to be compared.')
};
isEqual.defaultParameters = {
  firstValue: undefined,
  secondValue: undefined
};

module.exports = isEqual;
